import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type BackgroundMode = 'default' | 'none' | 'custom';

interface BackgroundState {
  mode: BackgroundMode;
  customImageUrl?: string;
  customImageName?: string;
}

// Load initial state from localStorage
const loadInitialState = (): BackgroundState => {
  try {
    const savedState = localStorage.getItem('backgroundState');
    if (savedState) {
      const parsed = JSON.parse(savedState);
      return {
        mode: parsed.mode || 'default',
        customImageUrl: parsed.customImageUrl || undefined,
        customImageName: parsed.customImageName || undefined,
      };
    }
  } catch (error) {
    console.error('Error loading background state from localStorage:', error);
  }
  
  return {
    mode: 'default', // default background image by default
  };
};

const initialState: BackgroundState = loadInitialState();

const backgroundSlice = createSlice({
  name: 'background',
  initialState,
  reducers: {
    setBackground(state, action: PayloadAction<BackgroundMode>) {
      state.mode = action.payload;
      // Save to localStorage
      localStorage.setItem('backgroundState', JSON.stringify(state));
    },
    toggleBackground(state) {
      state.mode = state.mode === 'none' ? 'default' : 'none';
      // Save to localStorage
      localStorage.setItem('backgroundState', JSON.stringify(state));
    },
    setCustomBackground(state, action: PayloadAction<{ url: string; name: string }>) {
      state.mode = 'custom';
      state.customImageUrl = action.payload.url;
      state.customImageName = action.payload.name;
      // Save to localStorage
      localStorage.setItem('backgroundState', JSON.stringify(state));
    },
    clearCustomBackground(state) {
      state.mode = 'none';
      state.customImageUrl = undefined;
      state.customImageName = undefined;
      // Save to localStorage
      localStorage.setItem('backgroundState', JSON.stringify(state));
    },
  },
});

export const { setBackground, toggleBackground, setCustomBackground, clearCustomBackground } = backgroundSlice.actions;
export default backgroundSlice.reducer;